import { action, computed, flow, makeObservable, observable, reaction } from 'mobx';
import { ApiResponse, GlobalStore } from '@roc/feature-app-core';
import { DocumentStore } from '@roc/feature-documents';
import { LoanStore } from '@roc/feature-loans';
import { TamariskPaymentService } from '../../services/documentForms/tamariskPaymentService';
import { AMCEnum } from '@roc/feature-utils';

export class TamariskPaymentStore {
  public loanStore: LoanStore;
  private documentStore: DocumentStore;
  private globalStore: GlobalStore;
  private tamariskPaymentService: TamariskPaymentService;
  public isInternal: boolean;
  public amcPaymentUrl: string = null;
  amcCompany: any;

  constructor(
    loanStore: LoanStore,
    documentStore: DocumentStore,
    globalStore: GlobalStore
  ) {
    this.loanStore = loanStore;
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.tamariskPaymentService = new TamariskPaymentService();
    this.isInternal = false;
    this.amcPaymentUrl = null;
    makeObservable(this, {
      requestAppraisalPayment: flow,
      reset: action,
      tamariskPaymentURL: computed,
      borrowersEmail: computed,
      isInternal: observable,
      setIsInternal: action,
      amcPaymentUrl: observable,
      fetchAmcPaymentUrl: flow,
      amcCompany: observable,
      getAmcById: flow,
      loadAmcAndPaymentUrl: flow
    });

    reaction(
      () => this.loanStore.loanDetails?.selectedAmcId,
      (selectedAmcId) => {
        if (selectedAmcId) {
          this.loadAmcAndPaymentUrl();
        }
      },
      { fireImmediately: true }
    );
  }

  *getAmcById(amcId: number) {
    try {
      const response: ApiResponse = yield this.tamariskPaymentService.getAmcById(amcId);
      this.amcCompany = response?.data?.data;
    } catch (error) {
      console.log('Error mapping AMC company', error)
    }
  }

  *requestAppraisalPayment(entityId: any, type: any) {
    try {
      yield this.tamariskPaymentService.requestAppraisalPayment(this.isInternal, entityId, type);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Payment email successfully sent',
      });
    } catch (err) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error on sending payment email',
      });
    }
  }

  reset() {
    // No reset logic required yet.
  }

  get tamariskPaymentURL() {
    const { tamariskPaymentURL, selectedAmcId } = this.loanStore?.loanDetails;
    if (AMCEnum.VSAMC === selectedAmcId || AMCEnum.EVALZONE === selectedAmcId) {
      return this.amcPaymentUrl;
    }
    return tamariskPaymentURL;
  }

  *fetchAmcPaymentUrl() {
    const response: ApiResponse = yield this.tamariskPaymentService.getAmcPayment(
      this.isInternal,
      this.loanStore.loanDetails?.loanId
    );

    const { data } = response;
    this.amcPaymentUrl = data?.data;
  }

  *loadAmcAndPaymentUrl() {
    yield this.getAmcById(this.loanStore?.loanDetails?.selectedAmcId);
  }

  get borrowersEmail() {
    return this.loanStore.loanDetails?.borrowers
      .filter(
        borrower =>
          borrower?.emailAddress != null &&
          borrower?.emailAddress != '' &&
          borrower?.emailAddress != undefined
      )
      .map(b => b.emailAddress)
      .join('; ');
  }

  setIsInternal(isInternal: boolean) {
    this.isInternal = isInternal;
  }
}

export default TamariskPaymentStore;
